import React, { useEffect, useState } from "react";
import { Link } from "react-router-dom";

import "react-data-table-component-extensions/dist/index.css";
import Header from "../layouts/Header";
import Sidebar from "../layouts/Sidebar";
import axios from "../api/axios";
import FindModuleById from '.././FindModuleById';
import { loader_image } from "../_components/Imagepath";
import {  base_url,Apitoken, Authtoken } from "../Global";

import {MaterialReactTable} from 'material-react-table';
import Swal from 'sweetalert2';

//Material UI Imports
import {

  MenuItem,

} from '@mui/material';

const CaisseEspace = () => {
  const [menu, setMenu] = useState(false);
  const [dataout, setDataout] = useState([]);
  const [datain, setDatain] = useState([]);
       const [permission, setPermission] = useState({});
  
  const [operationsum, setOperationsum] = useState([]);

  // const [backendSuccess, setBackendSuccess] = useState(null);
  // const [backendErrors, setBackendErrors] = useState(null);
    let season_id = localStorage.getItem("season_id");
  let para ={season_id:season_id};
  useEffect(() => {
        setPermission(FindModuleById(311)); 
console.log(permission);

    axios.post("/caisse/listing",para,{  headers: { Authorization: `Bearer ${Authtoken}`, Apitoken: Apitoken },})
      .then((response) => {
               if (response.data.code === 200) {
          setDataout(response.data.data.caisses_out);
          setDatain(response.data.data.caisses_in);
          setOperationsum(response.data.data.accumulations);
        }
        else  if (response.data.code === 401) {
          window.location.href = "/login";
        }else{
          window.location.href = "/login"; 
        }
      }).catch((error) => {
        console.log(error);
      });

  }, []);


  const editItem = (item)=>{
    window.location.href = "/caisse-espece-edit/"+item;
  }


  const deleteItem = (item) => {
    let season_id = localStorage.getItem("season_id");

    Swal.fire({
      title: 'Do you really want to delete this record?',
      //text: 'This action cannot be undone.',
      icon: 'warning',
      showCancelButton: true,
      confirmButtonColor: '#3085d6',
      cancelButtonColor: '#d33',
      confirmButtonText: 'DELETE'
    }).then((result) => {
      if (result.isConfirmed) {
        axios.get(`/caisse/delete/${season_id+'-'+item}`, {
              headers: { Authorization: `Bearer ${Authtoken}`, Apitoken: Apitoken },
            })
            .then((response) => {
              console.log(response);
              if (response.data.code === 200) {
                //setBackendSuccess(response.data.message);
                Swal.fire(
                  'Deleted!',
                  'Your Record has been deleted.',
                  'success'
                );
                setTimeout(() => {
                  window.location.href = "/caisse-espece";
                },500);
              }
            })
            .catch((error) => {
              console.log(error);
            });

        // Handle confirmed action here
        
      }
    });
    
  };

  const toggleMobileMenu = () => {
    setMenu(!menu);
  };


  const columns =
  [
  
     {
       accessorKey: 'payed_to', //normal accessorKey
       header: 'Payed To',
     }, 
  
  //    {
  //      accessorKey: 'expense_type', //normal accessorKey
  //      header: 'Expense Type',
  //    }, 
  //  {
  //     accessorKey: 'expense_type_other', 
  //     header: 'Expense Type Autre',
  //   },
      {
       header: 'Expense Type',
       accessorFn: (row) => `${(row.expense_type == 'Autre')?row.expense_type_other:row.expense_type} `,
     },
 
     {
       header: 'Amount',
       accessorFn: (row) => row.amount+`${(row.caisse_currency)?row.caisse_currency.symbol:""} `,
     },
     {
       accessorKey: 'date', //normal accessorKey
       header: 'Date',
     }, 
  
     {
       accessorKey: 'note', //normal accessorKey
       header: 'Note',
     }, 
     {
       header: 'Created By',
       accessorFn: (row) => `${(row.createdby)?row.createdby.first_name+ ' '+ row.createdby.last_name:""} `,
     },
     {
       header: 'Updated By',
       accessorFn: (row) => `${(row.updatedby)?row.updatedby.first_name+ ' '+ row.updatedby.last_name:""} `,
     },
   ];


   const columns_in =
   [
    {
      accessorKey: 'paid_by', //normal accessorKey
      header: 'Paid BY',
    }, 
    // {
    //   accessorKey: 'operation_type', //normal accessorKey
    //   header: 'Operation Type',
    // }, 
     {
       header: 'Operation Type',
       accessorFn: (row) => `${(row.operation_type == 'Autre')?row.operation_type_other:row.operation_type} `,
     },
    {
      accessorKey: 'payment_type', //normal accessorKey
      header: 'payment type',
    }, 
  
      {
        header: 'Amount',
        accessorFn: (row) => row.amount+`${(row.caisse_currency)?row.caisse_currency.symbol:""} `,
      },
      {
        accessorKey: 'date', //normal accessorKey
        header: 'Date',
      }, 
   
      {
        accessorKey: 'note', //normal accessorKey
        header: 'Note',
      }, 
      {
        header: 'Created By',
        accessorFn: (row) => `${(row.createdby)?row.createdby.first_name+ ' '+ row.createdby.last_name:""} `,
      },
      {
        header: 'Updated By',
        accessorFn: (row) => `${(row.updatedby)?row.updatedby.first_name+ ' '+ row.updatedby.last_name:""} `,
      },
    ];
   
    

    

  const downloadExcel = (e) => {
    let season_id = localStorage.getItem("season_id");

    console.log(e)
    window.open(`${base_url}/caisse/listing-excel-export?type=espece&season_id=${season_id}`, '_blank');


  }


  return (
    <div className={`main-wrapper ${menu ? "slide-nav" : ""}`}>
      <Header onMenuClick={() => toggleMobileMenu()} />
      <Sidebar />

      <div className="page-wrapper">
        <div className="content container-fluid">
          <div className="page-header">
            <div className="row align-items-center">
              <div className="col">
                <h3 className="page-title">Caisse Espece</h3>
                <ul className="breadcrumb">
                  <li className="breadcrumb-item">
                    <Link to="/profile">Profile</Link>
                  </li>
                  <li className="breadcrumb-item active">Caisse Espece</li>
                </ul>
              </div>
              <div className="col-auto">
                {permission && permission.add == 1 && (
                        <Link to="/caisse-espece-add" className="btn btn-primary me-1">
                        <i className="fas fa-plus"></i>
                      </Link>
                    )}

                
                &nbsp;&nbsp;
                  <button
                    className="btn btn-primary"
                    onClick={() => downloadExcel()}
                  >
                    <i className="fa fa-file-excel-o"></i>  <i className="fa fa-download"></i><img id="loader-image2" className="loader-image2 loader-hide2" src={loader_image}/>
                  </button> 
              </div>
            </div>
          </div>
          <div className="row">
                
            
          <div className="col-xl-2 col-lg-4 col-sm-6 col-12 d-flex">
                        <div className="card inovices-card w-100">
                          <div className="card-body">
                            <div className="dash-widget-header">
                              <div className="dash-count text-center">
                                <div className="dash-title">TOTAL IN</div>
                                <div className="dash-counts">
                                  <p>{operationsum.IN}</p>
                                </div>
                              </div>
                            </div>
                          
                          </div>
                        </div>
                      </div>
                      <div className="col-xl-2 col-lg-4 col-sm-6 col-12 d-flex">
                        <div className="card inovices-card w-100">
                          <div className="card-body">
                            <div className="dash-widget-header">
                              <div className="dash-count text-center">
                                <div className="dash-title">TOTAL OUT</div>
                                <div className="dash-counts">
                                  <p>{operationsum.OUT}</p>
                                </div>
                              </div>
                            </div>
                          
                          </div>
                        </div>
                      </div>
                         
                      <div className="col-xl-2 col-lg-4 col-sm-6 col-12 d-flex">
                        <div className="card inovices-card w-100">
                          <div className="card-body">
                            <div className="dash-widget-header">
                              <div className="dash-count text-center">
                                <div className="dash-title"> AVAILABLE</div>
                                <div className="dash-counts">
                                  <p>{operationsum.available}</p>
                                </div>
                              </div>
                            </div>
                          
                          </div>
                        </div>
                      </div>
                         <div className="col-xl-2 col-lg-4 col-sm-6 col-12 d-flex">
                        <div className="card inovices-card w-100">
                          <div className="card-body">
                            <div className="dash-widget-header">
                              <div className="dash-count text-center">
                                <div className="dash-title"> Total Vente déchets</div>
                                <div className="dash-counts">
                                  <p>{operationsum.vente_dechets}</p>
                                </div>
                              </div>
                            </div>
                          
                          </div>
                        </div>
                      </div>
                         
                      {/* <div className="col-xl-2 col-lg-4 col-sm-6 col-12 d-flex">
                        <div className="card inovices-card w-100">
                          <div className="card-body">
                            <div className="dash-widget-header">
                              <div className="dash-count text-center">
                                <div className="dash-title"> Cheque Non Encaisse</div>
                                <div className="dash-counts">
                                  <p>{operationsum.non_encaisse}</p>
                                </div>
                              </div>
                            </div>
                          
                          </div>
                        </div>
                      </div>
                                     
                      <div className="col-xl-2 col-lg-4 col-sm-6 col-12 d-flex">
                        <div className="card inovices-card w-100">
                          <div className="card-body">
                            <div className="dash-widget-header">
                              <div className="dash-count text-center">
                                <div className="dash-title"> Cheque Encaisse</div>
                                <div className="dash-counts">
                                  <p>{operationsum.encaisse}</p>
                                </div>
                              </div>
                            </div>
                          
                          </div>
                        </div>
                      </div>
                          */}
                 
                
               
                      
                </div>
          <div className="row">
            
            <div className="col-sm-12">
              <div className="card card-table">
                <div className="card-body">
                  <div className="table-responsive">
                
                  </div>
                </div>
              </div>
            </div>
            
              
            <div className="col-sm-12" >


          <div className="card bg-white">
                  {permission && permission.list == 1 && ( 
                       <div className="card-body">
                                      <ul className="nav nav-tabs nav-tabs-bottom">
                                      
                                    
                                      <li className="nav-item">
                                          <a className="nav-link active" href="#listing-groupby-supplier" data-bs-toggle="tab">OUT Opearations</a>                                  
                                      </li>
                                      <li className="nav-item">
                                          <a className="nav-link " href="#listing-all" data-bs-toggle="tab"> IN Opearations</a>                                   
                                      </li>                    
                                      </ul>
                                      <div className="tab-content">
                                    
                                      <div className="tab-pane show active" id="listing-groupby-supplier">
                                      <div className="row"   id="listing-followup">
                                        <div className="col-sm-12">
                                          <div className="card card-table">
                                            <div className="card-body">
                                                <div className="table-responsive">

                                               <MaterialReactTable columns={columns} data={dataout} 
                                    // enableColumnFilterModes
                                    enableColumnOrdering
                                    // enableGrouping
                                    enablePinning
                                    enableRowActions
                                    // enableRowSelection
                                    // initialState={{ showColumnFilters: true }}
                                  
                                    renderRowActionMenuItems={({ row }) => [
                                      permission?.update == 1 && (
                                        <MenuItem key="edit" onClick={() => editItem(row.original.id)}>
                                          Edit
                                        </MenuItem>
                                      ),
                                      permission?.delete == 1 && (
                                        <MenuItem key="delete" onClick={() => deleteItem(row.original.id)}>
                                          Delete
                                        </MenuItem>
                                      ),
                                    ]}
                                  />
                                                </div>
                                            </div>
                                          </div>
                                        </div>
                                      </div>
                                        
                                        </div>                                
                                        <div className="tab-pane  " id="listing-all">
                                          <div className="row"   id="listing-followup">
                                            <div className="col-sm-12">
                                              <div className="card card-table">
                                                <div className="card-body">
                                                    <div className="table-responsive">
                                                    <MaterialReactTable columns={columns_in} data={datain} 
                                                // enableColumnFilterModes
                                                enableColumnOrdering
                                                // enableGrouping
                                                enablePinning
                                                enableRowActions
                                                // enableRowSelection
                                                // initialState={{ showColumnFilters: true }}
                                              
                                                renderRowActionMenuItems={({ row }) => [
                                                    permission?.update == 1 && (
                                                      <MenuItem key="edit" onClick={() => editItem(row.original.id)}>
                                                        Edit
                                                      </MenuItem>
                                                    ),
                                                    permission?.delete == 1 && (
                                                      <MenuItem key="delete" onClick={() => deleteItem(row.original.id)}>
                                                        Delete
                                                      </MenuItem>
                                                    ),
                                                  ]}
                                              />
                                                    
                                                    </div>
                                                </div>
                                              </div>
                                            </div>
                                          </div>
                                        
                                        </div>                                
                                      
                                      </div>                             
                                  </div>

                    )}


            
           </div>
            
           </div>



          </div>
        </div>
      </div>
    </div>
  );
};
export default CaisseEspace;
